import React from "react";
import { Link } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";

export default function RoundSuccess() {
  return (
    <div
      style={{
        maxWidth: "650px",
        margin: "120px auto",
        backgroundColor: "#fff",
        padding: "40px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        textAlign: "center",
      }}
    >
      <FaCheckCircle size={80} color="#2e7d32" />

      <h1 style={{ marginTop: "20px", color: "#2e7d32" }}>
        Round Listing Created Successfully!
      </h1>

      <p style={{ color: "#444", marginTop: "10px", fontSize: "1.1rem" }}>
        Your lawn-mowing round listing has been posted and is now live on Client Exchange.
        Buyers can now view your listing and make enquiries.
      </p>

      {/* BUTTONS */}
      <div style={{ marginTop: "30px" }}>
        <Link to="/lawn-mowing/rounds">
          <button
            style={{
              backgroundColor: "#2e7d32",
              color: "#fff",
              padding: "12px 20px",
              border: "none",
              borderRadius: "8px",
              marginRight: "15px",
              cursor: "pointer",
              fontWeight: "bold",
              fontSize: "1rem",
            }}
          >
            View All Rounds
          </button>
        </Link>

        <Link to="/lawn-mowing/rounds/create">
          <button
            style={{
              backgroundColor: "#555",
              color: "#fff",
              padding: "12px 20px",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontWeight: "bold",
              fontSize: "1rem",
            }}
          >
            Create Another Round
          </button>
        </Link>
      </div>
    </div>
  );
}
